import { Component, OnInit } from '@angular/core';
import {SubscriptionModuleEnum} from "../../../modules/app/global/billings/enums/subscription-module.enum";
import {LoadingService} from "../../../modules/shared/services/loading.service";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnInit {

  SubscriptionModuleEnum = SubscriptionModuleEnum;
  submitted = false;
  formData: {
    typeSelected: string,
    modules: SubscriptionModuleEnum[],
    name: string,
    email: string,
    phone: string,
    terms: boolean,
    havePOS: boolean,
  } = {
    typeSelected: null,
    modules: [],
    name: null,
    email: null,
    phone: null,
    terms: false,
    havePOS: false,
  }

  constructor(
      private loadingService: LoadingService,
      private http: HttpClient
  ) { }

  ngOnInit(): void {
  }

  toggleModule(module: SubscriptionModuleEnum) {
    if (this.isModuleSelected(module)) {
      this.formData.modules = this.formData.modules.filter(m => m !== module);
    } else {
      this.formData.modules.push(module);
    }
  }

  isModuleSelected(module: SubscriptionModuleEnum): boolean {
    return this.formData.modules.includes(module);
  }

  save() {
    this.submitted = true;
    if (!this.isValid()) {
      return;
    }
    this.http.post('https://hook.eu2.make.com/nodtnin8t6rkgvvkzywfbsuibad8c72w', this.formData).subscribe()
    setTimeout(() => {
      window.location.href = 'https://fodimi.pl/kontakt/success';
    }, 2000)
  }

  private isValid(): boolean {
    return !!this.formData.name && this.formData.terms && !!this.formData.email && !!this.formData.phone
  }
}
